/** Mixin handles the logic and data to support pagination of lists of data
 * @mixin */

export default {
  data() {
    return {
      initialPageSize: 5,
      pageSize: 5,
      pageSizeOptions: [5, 10, 25, 50, 75, 100],
      currentPage: 1,
    };
  },
  computed: {
    orderedEntities() {
      // note, there is a slice before sort to keep from modifying the original array
      return this.entities
        .slice()
        .sort((a, b) => (this.entitySort(a, b)));
    },
    rows() {
      return this.orderedEntities.length;
    },
    visibleEntities() {
      return this.orderedEntities
        .slice(
          ((this.currentPage - 1) * this.pageSize),
          (this.currentPage * this.pageSize),
        );
    },
    firstVisibleEntry() {
      return ((this.currentPage - 1) * this.pageSize) + 1;
    },
    lastVisibleEntry() {
      if (this.rows > this.currentPage * this.pageSize) {
        return this.currentPage * this.pageSize;
      }
      return this.rows;
    },
  },
  methods: {
    updateCurrentPage(currentPage) {
      this.currentPage = currentPage;
    },
    updatePageSize(pageSize) {
      this.pageSize = pageSize;
    },
  },
};
